import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RUI_FIELD_DESCRIPTION_ATTR } from "../form/control-protocol";
export function RuiFieldDescription({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("p", {
    ...props,
    ...{
      [RUI_FIELD_DESCRIPTION_ATTR]: ""
    },
    class: cx("rui-field__description", className),
    children
  });
}